
export class AppVersion {

  number!: string;
  commit!: string;
  buildTime!: Date;

  static current: AppVersion = { number: '57', commit: '71e8bf1', buildTime: new Date('2026-06-02T02:00:54.521Z') };
}